var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilledStarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 28,
    viewBox: "0 0 30 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Star 3",
    filter: "url(#filter0_d_180_626)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4783 3.68328C13.9573 2.20918 16.0427 2.20918 16.5217 3.68328L18.233 8.95016C18.4472 9.60939 19.0615 10.0557 19.7547 10.0557H25.2926C26.8426 10.0557 27.487 12.0391 26.2331 12.9502L21.7528 16.2053C21.192 16.6127 20.9574 17.3349 21.1716 17.9941L22.8829 23.261C23.3618 24.7351 21.6747 25.9609 20.4207 25.0498L15.9405 21.7947C15.3797 21.3873 14.6203 21.3873 14.0595 21.7947L9.57927 25.0498C8.32533 25.9609 6.63816 24.7351 7.11713 23.261L8.82844 17.9941C9.04264 17.3349 8.80798 16.6127 8.2472 16.2053L3.76693 12.9502C2.51299 12.0391 3.15743 10.0557 4.70739 10.0557H10.2453C10.9385 10.0557 11.5528 9.60939 11.767 8.95016L13.4783 3.68328Z",
    fill: "#FFC805"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_180_626",
    x: 0.971159,
    y: 0.444303,
    width: 28.0577,
    height: 27.0518,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.06667
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_180_626"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_180_626",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledStarIcon);
export default __webpack_public_path__ + "static/media/filledStarIcon.58b572463185f8eef2603730ed167137.svg";
export { ForwardRef as ReactComponent };